import apiClient from '@/services/api-base'
import { useWebsocket } from '@/services/websocket';


export const state = {
  username: localStorage.getItem('ebslog.username'),
  useremail: localStorage.getItem('ebslog.useremail'),
  userId: localStorage.getItem('ebslog.userid'),
  token: localStorage.getItem('ebslog.token'),
  profilePicture: localStorage.getItem('ebslog.profilePicture')
};

export const mutations = {
  CHANGE_TOKEN(state, token) {
    state.token = token;
    saveState('ebslog.token', token);
  },
  CHANGE_USERNAME(state, username) {
    state.username = username;
    saveState('ebslog.username', username);
  },
  CHANGE_EMAIL(state, useremail) {
    state.useremail = useremail;
    saveState('ebslog.useremail', useremail);
  },
  CHANGE_USERID(state, userId) {
    state.userId = userId;
    saveState('ebslog.userid', userId);
  },
  CHANGE_PROFILEPICTURE(state, profilePicture) {
    state.profilePicture = profilePicture;
    saveState('ebslog.profilePicture', profilePicture);
  },
};


export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
      return !!state.token
  },
  userName(state) {
    return state.username
  },
  userEmail(state) {
    return state.useremail
  },
  token(state) {
    return state.token ?? ''
  },
  permissoes() {
    if ((state.token ?? '') != '') {
      return JSON.parse(window.atob(localStorage.getItem("ebslog.token").split(".")[1])).role
    }
    return []
  },
  profilePicture(state) {
    return state.profilePicture ?? null
  },
}


export const actions = {
    // Logs in the current user.
    logIn({ commit,  getters }, { email, password } = {}) {
      if (getters.loggedIn)  {
        commit('CHANGE_TOKEN', null)
        commit('CHANGE_USERNAME', null)
        commit('CHANGE_USERID', null)
        commit('CHANGE_EMAIL', null)
        commit('CHANGE_PROFILEPICTURE', null)
      }

      return new Promise((resolve, reject) => {
        apiClient.post('account/efetuar-login', { email, password }, false).then((response) => {
            commit('CHANGE_TOKEN', response.data.token)
            commit('CHANGE_USERNAME',  response.data.userName)
            commit('CHANGE_USERID',  response.data.userId)
            commit('CHANGE_EMAIL',  response.data.userEmail)
            commit('CHANGE_PROFILEPICTURE',  response.data.foto)
            const ws = useWebsocket()
            ws.tryStart();
            resolve(true);
        }).catch(err => {
          reject(err);
        })
      });
  },
  updateToken({ commit}, token){
    commit('CHANGE_TOKEN', token)
  },
  updateUserAvatar({ commit }, avavar) {
    commit('CHANGE_PROFILEPICTURE', avavar)
  },
  updateUserNome({ commit }, nome) {
    commit('CHANGE_USERNAME', nome)
  }
}


// ===
// Private helpers
// ===
function saveState(key, value) {
  if (!value) {
    localStorage.removeItem(key)
  } else {
    localStorage.setItem(key, value)
  }
}